import { IFunctionMapping } from '../interfaces';
import { FunctionMappingType } from '../types';
import { FunctionMappingNotFound } from './errors';

export function readFunctionMapping(
    functionName: string,
    functionMapping: IFunctionMapping,
    params: unknown,
    functionMappingType: FunctionMappingType,
) {
    const fnMapping = functionMapping[functionName];
    if (!fnMapping) throw new FunctionMappingNotFound(functionName);
    const functionConfig = fnMapping(params);
    return functionConfig?.[functionMappingType];
}

export function existFunctionMappingTypeConfig(
    functionName: string,
    functionMapping: IFunctionMapping,
    params: unknown,
    functionMappingType: FunctionMappingType,
): boolean {
    const fnMapping = functionMapping[functionName];
    if (!fnMapping) return false;

    const functionConfig = fnMapping(params);
    return !!functionConfig?.[functionMappingType];
}
